import Spacer from "@p-ban/common/src/components/layout/Spacer"

import MyPageMainContent from "../../../components/mypage/MyPageMainContent"
import Text from "../../../components/ui/Text/Text"

import title from "../images/title.png"

const SignUpInvalid = () => {
  return (
    <MyPageMainContent src={title} alt="新規ユーザー登録">
      <Spacer size={40} />
      <Text>URLの有効期限切れ、またはURLが無効です。</Text>
    </MyPageMainContent>
  )
}

export default SignUpInvalid
